var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"html-body"}},[_c('div',{staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.html)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12 col-md-12 py-5"},[_c('h1',{staticClass:"display-4"},[_vm._v(" ABOUT US ")])])
}]

export { render, staticRenderFns }